import React, {
  ElementType,
  FC,
  useContext,
  ReactNode,
  useCallback,
} from "react";
import { TabSwitcherContext } from "./TabContext";

export interface ITabLinkProps {
  /**
   * Sets a custom html element for this component
   *
   * @default 'div'
   */
  as?: ElementType;

  /**
   * Set tab ID that will match with `TabPane` you attach.
   */
  tabDisplayId?: string;
  children?: ReactNode;
}

const TabLink: FC<ITabLinkProps> = (props) => {
  const { as: Component = "div", tabDisplayId, children, ...other } = props;
  const context = useContext(TabSwitcherContext);

  const handleClick = useCallback(() => {
    tabDisplayId && context?.onSelect(tabDisplayId);
  }, [context, tabDisplayId]);

  return (
    <Component data-testid="tabLink-component" onClick={handleClick} {...other}>
      {children}
    </Component>
  );
};

export default TabLink;
